import { BLEKeyDeliveryStatus } from '@app/shared/models/nms.models';

/**
 * There can be different steps in NetworkMigration and each step having different status that needs to be mapped to be displayed as
 *  Running, Failed , Attention, Completed with their respective styles
 */
export type NetworkMigrationStatus = `${BLEKeyDeliveryStatus}`;

export enum NetworkMigrationStatusLabel {
  Running = 'Running',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Failed = 'Failed',
  Pending = 'Pending',
  Created = 'Created',
  NoOpenJoiningSession = 'No Open Joining Session',
  WaitingForOpenJoiningToFinish = 'Waiting for Open Joining to Finish'
}

export const NETWORK_MIGRATION_STATUS_LABELS: Record<NetworkMigrationStatus, NetworkMigrationStatusLabel> = {
  IN_PROGRESS: NetworkMigrationStatusLabel.Running,
  PENDING: NetworkMigrationStatusLabel.Pending,
  CREATED: NetworkMigrationStatusLabel.Created,
  CANCELLED: NetworkMigrationStatusLabel.Cancelled,
  COMPLETED: NetworkMigrationStatusLabel.Completed,
  FAILED: NetworkMigrationStatusLabel.Failed,
  ACTION_REQUIRED: NetworkMigrationStatusLabel.Failed,
  NO_OPEN_JOINING_SESSION: NetworkMigrationStatusLabel.NoOpenJoiningSession,
  WAITING_FOR_OPEN_JOINING_TO_FINISH: NetworkMigrationStatusLabel.WaitingForOpenJoiningToFinish,
};

export type NetworkMigrationTableRow = {
  id: number;
  status: NetworkMigrationStatus;
  statusLabel: string;
  statusClass: string;
  buildingName: string;
  buildingId: number;
  customer: string | null;
  totalNodes: number | null;
  completedNodes: number | null;
  progressPercent: number | null;
  lastUpdatedLabel: string;
  requiresAttention: boolean;
  actionLabel?: string;
  isHighlighted?: boolean;
};

export type NetworkMigrationWorkflow = {
  workflowId: number;
  buildingId: number;
  status: NetworkMigrationStatus;
  errorDetail: string;
  startedAt: string;
  completedAt: string;
  updatedAt: string;
  totalNodes: number;
  completedNodes: number;
};

export type NetworkMigrationWorkflows = NetworkMigrationWorkflow[];

export type NetworkMigrationWorkflowContext = Pick<
  NetworkMigrationTableRow,
  'id' | 'buildingName' | 'buildingId' | 'customer' | 'status' | 'lastUpdatedLabel'
>;
